import React  from "react";
import { Container, Card, CardBody, Media } from "reactstrap";
import { Link } from 'react-router-dom';

import CupImg     from "~/assets/images/tournament/cup.png";
import GamesImage from "~/assets/images/games.png";

import AnnouncementsPaginator from "./Announcements/Paginator/Announcements";
import GettingStarted         from "./GettingStarted";

import PointsWheelModal       from "./Modals/PointsWheelModal";
import PointsBooster          from "./PointsBoosters";
import DailyGoals             from "./DailyGoals";


const HomePage = ({setExpandedHeader, breakpoint})=> {

  return (
    <div className="dashboard-page p-t-30">

      <PointsWheelModal />

      <Container fluid={true}>

        <DailyGoals/>

        <AnnouncementsPaginator breakpoint={breakpoint} />

        <PointsBooster />

        <GettingStarted setExpandedHeader={setExpandedHeader} breakpoint={breakpoint} />

        { /* <Link to={{pathname: '/tournament'}} className="text-dark">
          <Card className="activity-card">
            <CardBody>
              <Media className="faq-widgets">
                <Media body>
                  <h6 className="title"> Game Tournament with daily prizes! </h6>
                  <small>We have a <strong>5,000</strong> points prize pool daily for our top <strong>100</strong> players! </small> <br/>
                  <small>Earn extra points daily while playing our exciting games.</small>
                </Media>
                <img src={CupImg} />
              </Media>
            </CardBody>
          </Card>
        </Link> */ }

        { /* <Link to={{pathname: '/games'}} className="text-dark">
          <Card className="activity-card">
            <CardBody>
              <Media className="faq-widgets">
                <Media body>
                  <h6 className="title"> Play games and reach the target score! </h6>
                  <small> We have <strong>5 new games </strong> where once you reach the target score you will get the points instantly. </small> <br/>
                  <small> Adblock is not accepted! </small>
                </Media>
                <img src={GamesImage} style={{alignSelf:"flex-end"}} />
              </Media>
            </CardBody>
          </Card>
        </Link> */ }

      </Container>
    </div>
  );
};

export default HomePage;
